import { useEffect, useState } from 'react';
import apiService from '../../axios/apiService';

export const useDashboard = () => {
  const [data, setData] = useState();
  const getList = async () => {
    try {
      // Fetch clinics list
      const result = await apiService.getDashboard();
      result && setData(result); // update data state
      return result;
    } catch (error) {
      return;
    }
  };

  // Initial Render
  useEffect(() => {
    getList();
  }, []);

  return {
    data,
    getList,
  };
};
